module.exports = __webpack_public_path__ + "static/img/img-nonface.4bb565b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c28/img-nonface.jpg
// module id = rW0Q
// module chunks = 0